export const handleEmailClick = () => {
  const recipientEmail = "wheatearstraw@gmail.com";
  const mailtoLink = `mailto:${recipientEmail}`;
  window.location.href = mailtoLink;
};

export default handleEmailClick;
